import { render, staticRenderFns } from "./ChatLogItemMensagemReferenciaConteudoTexto.vue?vue&type=template&id=d634350c&"
import script from "./ChatLogItemMensagemReferenciaConteudoTexto.vue?vue&type=script&lang=js&"
export * from "./ChatLogItemMensagemReferenciaConteudoTexto.vue?vue&type=script&lang=js&"
import style0 from "./ChatLogItemMensagemReferenciaConteudoTexto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
